import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';
import { CurrencyInfo } from '../../report-data/models/currency-info.model';
import { StatementOverviewMetric } from './statement-overview-metric.model';

export const STATEMENT_METRICS_SCHEMA = Object.freeze({
  CURRENCY_INFO: CurrencyInfo,
  SUMMARY: StatementOverviewMetric,
  OVERDUE: StatementOverviewMetric,
  UNPAID: StatementOverviewMetric,
});
const RECORD = generateSchema(STATEMENT_METRICS_SCHEMA);
const KEYS: any = generateKeys(STATEMENT_METRICS_SCHEMA);

export class StatementMetrics extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    const selfModel = setInModel(this, [
      {
        key: KEYS.CURRENCY_INFO,
        value: new CurrencyInfo(this.currencyInfo),
      },
      {
        key: KEYS.SUMMARY,
        value: new StatementOverviewMetric(this.summary),
      },
      {
        key: KEYS.OVERDUE,
        value: new StatementOverviewMetric(this.overdue),
      },
      {
        key: KEYS.UNPAID,
        value: new StatementOverviewMetric(this.unpaid),
      },
    ]);

    return selfModel as StatementMetrics;
  }

  get currencyInfo(): CurrencyInfo {
    return this.get(KEYS.CURRENCY_INFO);
  }

  get summary(): StatementOverviewMetric {
    return this.get(KEYS.SUMMARY);
  }

  get overdue(): StatementOverviewMetric {
    return this.get(KEYS.OVERDUE);
  }

  get unpaid(): StatementOverviewMetric {
    return this.get(KEYS.UNPAID);
  }
}
